module.exports = __webpack_public_path__ + "assets/img/yoan.653a3f09.jpg";